"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplaceButton = void 0;
var _openProductInfoDialog = require("@ori-events/open-product-info-dialog");
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ReplaceButton = ({
  productCode,
  title,
  disabled,
  isPrimary,
  placement,
  replacementCodes = [],
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const openReplacementsDialog = (0, _react.useCallback)(() => window.dispatchEvent(new CustomEvent(_openProductInfoDialog.Name, {
    detail: {
      mode: _openProductInfoDialog.DialogMode.StandardBuy,
      originalItemCode: productCode,
      placement,
      productCodes: replacementCodes
    }
  })), [placement, productCode, replacementCodes]);
  if (replacementCodes.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    color: isPrimary ? 'primary' : 'default',
    variant: isPrimary ? 'contained' : 'outlined',
    "data-testid": getTestId(_constants.REPLACE_BUTTON),
    disabled: disabled,
    startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Replace, {}),
    onClick: onClick ?? openReplacementsDialog,
    children: title
  });
};
exports.ReplaceButton = ReplaceButton;
//# sourceMappingURL=ReplaceButton.js.map